module.exports = __webpack_public_path__ + "img/cat4.049942a3.jpg";